import { render } from "./TeamsMenu.vue?vue&type=template&id=f8570500&scoped=true"
import script from "./TeamsMenu.vue?vue&type=script&lang=js"
export * from "./TeamsMenu.vue?vue&type=script&lang=js"

import "./TeamsMenu.vue?vue&type=style&index=0&id=f8570500&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8570500"]])

export default __exports__